export default "__VITE_ASSET__ChpFze5H__"